import React, { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function validatePasswordForm({ current, next, confirm }) {
  if (!current) return "Password saat ini wajib diisi";
  if (!next) return "Password baru wajib diisi";
  if (next.length < 8 || next.length > 128) return "Password baru harus 8–128 karakter";
  if (!confirm) return "Konfirmasi password baru wajib diisi";
  if (next !== confirm) return "Konfirmasi password tidak sama";
  if (next === current) return "Password baru harus berbeda dari password saat ini";
  return "";
}

const Field = ({ id, label, value, onChange, testId }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-white/70">{label}</Label>
    <Input id={id} type="password" autoComplete={id === "current" ? "current-password" : "new-password"} value={value}
      onChange={(e) => onChange(e.target.value)} className="bg-white/5 border-white/10 text-white" data-testid={testId} />
  </div>
);

export function SecurityTab({ mustChange, onChanged }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const v = validatePasswordForm({ current, next, confirm });
    setError(v);
    if (v) return;
    setBusy(true);
    try {
      await api.post("/platform/me/change-password", { current_password: current, new_password: next, confirm_new_password: confirm });
      toast.success("Password diperbarui. Silakan login ulang.");
      onChanged?.();
    } catch (err) {
      const msg = formatApiError(err) || "Gagal mengganti password";
      setError(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-5 max-w-md" data-testid="account-security-form">
      {mustChange ? (
        <div className="rounded-xl border border-amber-400/30 bg-amber-400/10 px-3 py-2.5 text-sm text-amber-200" data-testid="account-must-change-notice">
          Anda wajib mengganti password sementara sebelum mengakses menu lain.
        </div>
      ) : null}
      <Field id="current" label="Password saat ini" value={current} onChange={setCurrent} testId="account-current-password" />
      <Field id="new" label="Password baru" value={next} onChange={setNext} testId="account-new-password" />
      <Field id="confirm" label="Konfirmasi password baru" value={confirm} onChange={setConfirm} testId="account-confirm-password" />
      <p className="text-xs text-white/40">Setelah password diganti, semua sesi Platform (termasuk sesi ini) akan keluar dan Anda diminta login ulang.</p>
      {error ? <div className="text-sm text-red-300" role="alert" data-testid="account-security-error">{error}</div> : null}
      <Button type="submit" disabled={busy} className="dynicty-gradient-bg text-white font-bold" data-testid="account-security-save">
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <KeyRound size={16} className="mr-2" />} Ubah Password
      </Button>
    </form>
  );
}
